import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Subscribe from '../components/Subscribe'
import Ticket from '../components/Ticket'

const Finalticket = () => {
  const { orderId } = useParams()
  const location = useLocation()
  const [order, setOrder] = useState(null)
  const stateOrder = location.state?.order || null
  const stateOrderId = location.state?.orderId || null

  const matchesOrderId = useMemo(() => {
    const target = orderId || stateOrderId
    if (!target) return () => true
    return (candidate) => {
      if (!candidate) return false
      const candidateId = candidate._id || candidate.orderId || candidate.order_id
      const candidateEventId = typeof candidate.eventId === 'string' ? candidate.eventId : candidate.eventId?._id
      return candidateId === target || candidateEventId === target
    }
  }, [orderId, stateOrderId])

  useEffect(() => {
    let isMounted = true
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    console.log("API_BASE_URL:", API_BASE_URL);

    const loadOrders = async () => {
      try {
        if (stateOrder && matchesOrderId(stateOrder)) {
          if (isMounted) {
            setOrder(stateOrder)
          }
          return
        }
        const token = localStorage.getItem('token')
        const response = await fetch(`${API_BASE_URL}/api/v1/orders/my-orders?page=1&limit=10`, {
          headers: {
            authorization: token ? `Bearer ${token}` : ''
          }
        })
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.message || 'Failed to load orders')
        }
        const items = Array.isArray(data.orders) ? data.orders : []
        const selected = (orderId || stateOrderId)
          ? items.find((item) => matchesOrderId(item))
          : items[0]
        if (isMounted) {
          setOrder(selected || null)
        }
      } catch (error) {
        console.error('Failed to load orders', error)
      }
    }

    loadOrders()

    return () => {
      isMounted = false
    }
  }, [orderId, matchesOrderId, stateOrder, stateOrderId])

  return (
    <>
    
    <Ticket order={order} variant="final" />
    <Subscribe />
    </>
  )
}

export default Finalticket
